import React from 'react';

function HistoryIcon({ className = '', fill = '#212121' }) {
	return (
		<svg
			className={className}
			width='48'
			height='48'
			viewBox='0 0 48 48'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_1357_45479)'>
				<path
					d='M26 6C16.06 6 8 14.06 8 24H2L9.78 31.78L9.92 32.06L18 24H12C12 16.26 18.26 10 26 10C33.74 10 40 16.26 40 24C40 31.74 33.74 38 26 38C22.14 38 18.64 36.42 16.12 33.88L13.28 36.72C16.54 39.98 21.02 42 26 42C35.94 42 44 33.94 44 24C44 14.06 35.94 6 26 6ZM24 16V26L32.5 31.04L34.04 28.48L27 24.3V16H24Z'
					fill={fill}
				/>
			</g>
			<defs>
				<clipPath id='clip0_1357_45479'>
					<rect width='48' height='48' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
}

export default HistoryIcon;
